// extracted by mini-css-extract-plugin
export var addToCartButton = "_op-b";
export var arrowButtonContainer = "_op-9";
export var arrowButtonIcon = "_op-a";
export var carouselArrowButton = "_op-6";
export var carouselElementContainer = "_op-1";
export var left = "_op-7";
export var productDisplayCarouselContainer = "_op-0";
export var productTileContainer = "_op-2";
export var productTileImage = "_op-4";
export var productTileImageContainer = "_op-3";
export var productTileTitle = "_op-5";
export var right = "_op-8";
export var sliderOverflow = "_op-c";